export default __webpack_public_path__ + "media/gs_upgrade_email/ftr_logo-49d0564a.png";